<template>
    <!-- <div class="popup3" :class="{active: popupShow}">
        <div class="popup__wrap">
            <button type="button" class="close" @click="popupBtn"><img src="@/assets/resource/icon/close-white.svg" alt=""></button>
            <div class="popup__inner">
                <div class="cont">
                    <div class="img">
                        <img src="@/assets/resource/img/floor-popup.png" alt="">
                    </div>
                </div>
                <button type="button" class="main-button c-main pc-none" @click="popupBtn">닫기</button>
            </div>
        </div>
    </div> -->
    <div class="layout">
        <div class="layout__inner">
            <div class="layout__floor">
                <ul class="layout__floor-list" v-if="depthList['2'] != null">
                    <li class="layout__floor-item" :class="{active: current.floor == item.placeNm}"  v-for="(item, idx) in depthList['2']" :key="idx">
                        <button type="button" @click="getLookAroundList(3, item)">{{item.placeNm}}</button>
                    </li>
                </ul>
            </div>
            <div class="layout__info">
                <div class="layout__store">
                    <h4 class="layout__store-tit">{{current.floor}}</h4>
                    <ul class="layout__store-list">
                        <template v-for="(item, idx) in depthObj[current.placeNm]" :key="idx">
                            <li class="layout__store-item" :class="{active: current.name == item.name}" v-if="current.floor == item.floor">
                                <button type="button" @click="setCurrent(item)"><span v-if="item.floor_num">{{item.floor_num}}</span>{{item[clsfLang()]}}</button>
                            </li>
                        </template>
                    </ul>
                </div>
                <div class="layout__map" v-if="img">
                    <p class="layout__map-text"  v-if="$store.state.hospStore.host === 'H0008'">
                        * 엄마아기병원은 <span>2층</span>,<span>8층 </span> 에 위치하고 있습니다.
                    </p>
                    <!-- <h3 class="tit"><span class="num">{{current.floor}}</span><span class="circle"></span></h3> -->
                    <div class="pin" v-show="showPin">
                        <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="@/assets/resource/icon/pin.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="@/assets/resource/icon/pin-brain.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="@/assets/resource/icon/pin-mom.svg" class="" alt="">
                    </div>
                    <img :src="`/displayFile.do?name=${ img.attachBag.lookAroundPhoto[0].savedName }`" :alt="img.attachBag.lookAroundPhoto[0].altValue" v-if="img.attachBag.lookAroundPhoto" @load="imageLoad">
                </div>
            </div>
        </div>
        <!-- <div class="layout__btn">
            <div class="botton-wrap">
                <a href="javascript:;" class="main-button small c-main" @click="popupBtn">층별 외래번호 안내</a>
            </div>
        </div> -->
    </div>
</template>


<script>
export default {
    data() {
        return {
            depthList:{},
            place:null,
            placeTypeList:[],
            placeType:'A',
            searchPlaceCd:'',

            img: '',
            pinArr: [],
            depthObj: {},
            current: {},
            goTwo: true,
            searchList: {},
            building: [],

            showPin: false,

            popupShow: false,

            imgLoad: false,
        }
    },
    methods: {
        clsfLangKo(){
            const lang = this.$store.getters.getLang
            let result = '영문'
            if(lang == 'en'){
                result = '영문'
            }else if(lang == 'ar'){
                result = '아랍어'
            }else if(lang == 'mn'){
                result = '몽골어'
            }else if(lang == 'ru'){
                result = '러시아어'
            }else if(lang == 'zh'){
                result = '중문'
            }
            return result
        },
        clsfLang(){
            const lang = this.$store.getters.getLang
            let result = 'en'
            if(lang == 'ar'){
                result = 'arab'
            }else if(lang == 'zh'){
                result = 'cn'
            }else if(lang == 'mn'){
                result = 'mon'
            }else{
                result = lang
            }
            return result + '_name'
        },
        imageLoad(){
            this.imgLoad = true
        },
        popupBtn() {
            this.popupShow = !this.popupShow
        },
        getLookAroundList(depth, item, chng){
            var params = {
                hospId: this.$store.getters.getHost
            }
            if(item) params.parentPlaceCd = item.placeCd;
            this.axios
                .get(this.api.lookAround.lookAroundList, {params})
                .then(res => {
                    this.depthList[depth] = res.data.list;
                    var totCnt = res.data.totCnt;

                    if(totCnt > 0){
                        if(depth == 1){
                            for(let i of this.depthList[depth]){
                                if(i.placeNm == this.clsfLangKo()){
                                    this.getLookAroundList(depth + 1, i);
                                    break
                                }
                            }
                        }else{
                            this.getLookAroundList(depth + 1, this.depthList[depth][0]);
                        }
                        // this.getLookAroundList(depth + 1, this.depthList[depth][0]);
                    }else{
                        this.getLookAround(item.placeCd);
                    }

                    if(this.building == ''){
                        this.building = res.data.list;
                        this.current.placeNm = res.data.list[0].placeNm;
                        this.getPin();
                    }

                    if(chng != null) {
                        this.goTwo = chng;
                    }

                    if(depth == 2){
                        this.current.placeNm = item.placeNm;
                    }

                    if(depth == 3){
                        if(this.goTwo){
                            for (let i of this.depthList['2']) {
                                if (i.placeNm == 'B2') {
                                    this.getImg(i.placeCd);
                                    this.goTwo = false;
                                    const move = setInterval(() => {
                                        if(this.pinArr.length > 0 && this.imgLoad) {
                                            this.setCurrent(i);
                                            clearInterval(move);
                                        }
                                    }, 100);
                                    setTimeout(() => {
                                        clearInterval(move);
                                    }, 2000);
                                    break;
                                }
                            }
                        }else{
                            this.getImg(item.placeCd);
                            const move = setInterval(() => {
                                if(this.pinArr.length > 0) {
                                    this.setCurrent(item);
                                    clearInterval(move);
                                }
                            }, 100);
                            setTimeout(() => {
                                clearInterval(move);
                            }, 2000);
                        }
                    }
                })
        },
        getImg(placeCd){
            this.axios.get(this.api.lookAround.lookAround, {
                params: {
                    hospId: this.$store.getters.getHost,
                    placeCd: placeCd,
                }
            }).then(res => {
                this.img = res.data.query;
            })
        },
        getLookAround(placeCd){
            this.axios
                .get(this.api.lookAround.lookAround,
                    {
                        params: {
                            hospId: this.$store.getters.getHost,
                            placeCd: placeCd,
                        }
                    })
                .then(res => {
                    this.place = res.data.query;
                })
        },
        getSearchLookAround(depth, item, curItem){
            var params = {
                hospID: this.$store.getters.getHost
            }
            if(item) params.parentPlaceCd = item.placeCd;
            this.axios
                .get(this.api.lookAround.lookAroundList, {params})
                .then(res => {
                    this.depthList[depth] = res.data.list;

                    if(depth == 2){
                        this.current.placeNm = item.placeNm;
                        for(let i of res.data.list){
                            if(i.placeNm == curItem.floor){
                                this.getSearchLookAround(depth + 1, i, curItem);
                            }
                        }
                    }

                    if(depth == 3){
                        this.getSearchLookAround(depth + 1, item, curItem);
                        this.getImg(item.placeCd);
                        this.setCurrent(curItem);
                    }

                    if(depth == 4){
                        this.getLookAround(item.placeCd);
                    }
                })
        },
        getPin(){
            this.axios.get(this.api.lookAround.pinList, {
                params: {
                    hospId: this.$store.getters.getHost
                }
            })
            .then(res => {
                this.pinArr = res.data;
                this.getTypeList();

                if(this.pinArr.length == 0) return;

                this.pinArr.forEach(item => {
                    // var building = item.floor.split('_')[0];
                    var building = this.clsfLangKo();

                    this.depthObj[building] = this.depthObj[building] || [];

                    const floorInfo = {}
                    Object.keys(item).forEach(key => {
                        floorInfo[key] = key == 'floor' ? item[key].replace('본관' + '_', '') : item[key]
                    })

                    this.depthObj[building].push(floorInfo);
                });

                // x, y값을 array 형태로 전환
                for(let i of this.building){                    
                    if(this.depthObj[i.placeNm] != null){
                        var grouped = {};

                        this.depthObj[i.placeNm].forEach(function (obj) {
                            var name = obj.name;
                            var floor = obj.floor;
                            var objKey = name + '_' + floor
                            if (!grouped[objKey]) {
                                grouped[objKey] = {}
                                Object.keys(obj).forEach(key => {
                                    if(key !== 'x' && key !== 'y'){
                                        grouped[objKey][key] = obj[key]
                                    }
                                })
                                grouped[objKey]['x'] = []
                                grouped[objKey]['y'] = []
                            }
                            grouped[objKey]['x'].push(obj.x);
                            grouped[objKey]['y'].push(obj.y);
                        });

                        this.depthObj[i.placeNm] = Object.values(grouped);
                    }
                }

                for(let i of this.building){
                    if(this.depthObj[i.placeNm] != null){
                        this.depthObj[i.placeNm].sort((a, b) => {
                            return a.seq - b.seq;
                        })   
                    }                    
                }
            })
        },
        simpleMove(xArr, yArr){
            var x = xArr;
            var y = yArr;

            $('.pin.multiple').remove();

            if (x == null && y == null) {
                $('.pin').removeClass('active');
            } else {
                $('.pin > img').addClass('active');
                let width = Number($('.layout__map  > img').css("width").replace('px', ''))
                let height = Number($('.layout__map  > img').css("height").replace('px', ''))
                if(width == 0) width = window.innerWidth > 1024 ? window.innerWidth * 0.56 : window.innerWidth - 51;
                let paddingTop = Number($('.layout__map').css('padding-top').replace('px', ''))
                let pointerX = Number($('.pin > img').css("width").replace('px', '')) || 52;
                let pointerY = Number($('.pin > img').css("height").replace('px', '')) || 66;
                if (x.length > 0) {
                    // let xC = (width / 960) * Number(x[0]) - pointerX / 2
                    // let yC = (width / 960) * Number(y[0]) * (8 / 9) - pointerY + (window.innerWidth > 1024 ? 0 : paddingTop);
                    const value = this.$store.getters.getHost == 'H0008' ? 40 : 0
                    let xC = (width / 900) * Number(x[0]) - pointerX / 2
                    let yC = ((height / 800) * Number(y[0]) - pointerY) + value
                    
                    if ($('.pin').hasClass('active')) {
                        $('.pin').animate({ top: yC, left: xC }, 1000);
                    } else {
                        $('.pin').addClass('active');
                        $('.pin').animate({ top: yC, left: xC }, 0);
                    }

                    if (x.length > 1) {
                        for (let i = 1; i < x.length; i++) {
                            // let xC = (width / 960) * Number(x[0]) - pointerX / 2
                            // let yC = (width / 960) * Number(y[0]) * (8 / 9) - pointerY + (window.innerWidth > 1024 ? 0 : paddingTop);
                            let xC = (width / 900) * Number(x[i]) - pointerX / 2
                            let yC = ((height / 800) * Number(y[i]) - pointerY) + value

                            const pointer = $('.pin').clone();
                            pointer.addClass('multiple');
                            pointer.css('top', yC + 'px');
                            pointer.css('left', xC + 'px');
                            pointer.find('p').text(this.current.name);
                            $('.pin').after(pointer);
                        }
                    }
                }
            }
        },
        setCurrent(item){
            var floor = item.floor != null ? item.floor : item.placeNm;
            var name = item.name;
            var x = item.x;
            var y = item.y;
            if(name == null){
                for(let i of this.depthObj[this.current.placeNm]){
                    if(floor == i.floor){
                        name = i.name;
                        x = i.x;
                        y = i.y;
                        break;
                    }
                }
            }
            
            var placeNm = '';
            this.current = { floor: floor, name: name, x: x, y: y, placeNm: this.current.placeNm };
            
            if(this.current.x != null && this.current.y != null){
                const move = setInterval(() => {
                    if($('.pin').length > 0) {
                        this.showPin = true
                        this.simpleMove(this.current.x, this.current.y);
                        clearInterval(move);
                    }
                }, 100);
                setTimeout(() => {
                    clearInterval(move);
                }, 2000);
            }else{
                $('.pin').removeClass('active');
            }
        },
        getTypeList(){
            this.searchPlaceCd = '';
            this.placeTypeList = this.searchList[this.placeType];
        },
    },
    mounted() {
        this.getLookAroundList(1);
    },
}
</script>